import React, { FunctionComponent, useEffect, useState } from 'react';
import OrganizationListItem from './OrganizationListItem';
import { getSortedRankArrayByName } from 'src/helpers/ranking.helper';
import { Organization } from 'src/model/organizations/organizations';
import './OrganizationList.scss';

interface Props {
  list: Array<Organization>;
}

const OrganizationList: FunctionComponent<Props> = (props: Props) => {
  const [ranking, setRanking] = useState<string[]>([]);
  const { list } = props;
  const DEFAULT_CLASS = 'organizationList';
  const WRAPPER_CLASS = `${DEFAULT_CLASS}__wrapper`;

  useEffect(() => {
    const getRanking = async () => {
      const ranking = await getSortedRankArrayByName('organizations');
      setRanking(ranking);
    };

    getRanking();
  }, []);

  return (
    <div className={WRAPPER_CLASS}>
      {list
        .sort((a, b) => ranking.indexOf(b.id) - ranking.indexOf(a.id))
        .map((organization) => (
          <OrganizationListItem
            key={organization.id}
            id={organization.id}
            name={organization.name}
            imageUrl={organization.imageUrl}
            externalUrl={organization.externalUrl}
            verified={organization.verified}
          />
        ))}
    </div>
  );
};

export default OrganizationList;
